const routes = {
  /*employees: {
    base: '/empleados',
    new: '/nuevo',
    edit: '/editar/:hash',
    query: '/consultar/:hash',
  },*/
  employers: '/empresas',
  employerSettings: {
    base: '/empresa',
  },
  forgotPassword: '/recuperar',
  home: '/home',
  login: '/login',
  newEmployer: '/crear-empresa',
  oauth: '/oauth',
  registry: '/registro',
  resetPassword: '/restablecer',


  dashboard: '/',
  employees: '/empleados',
  payroll: '/nomina',
  company: '/empresa',
  profile: '/perfil',
}

export const redirectRoute = {
  public: routes.login,
  private: routes.employers,
  privateEmployer: routes.home,
}

export default routes
